import Title from './default'

export default Title
